import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import { green } from '@mui/material/colors';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import { RedSalsa } from '@core/theme/baseTheme';

export default function FormStatus({active, lan}) {

    return (
        <React.Fragment>
            <Tooltip title={active?lan.active: lan.inactive}>
                {active?
                    <CheckCircleIcon style={{color: green[500]}} />
                    :
                    <RemoveCircleIcon sx={{color: RedSalsa}} />

                }
            </Tooltip>
        </React.Fragment>
    );
}